/* globals angular, _ */
(function() {
  'use strict';

  function ChartsCtrl (
    ChartsService,
    ClienteResource,
    localStorageService,
    moment
  ) {
    var ctrl = this;
    var user = localStorageService.get('user');
    ctrl.$onInit = function () {
      ctrl.bars = {
        onDate: { label: 'Entregues dentro do prazo', value: '' },
        overdue: { label: 'Entregues com atraso', value: '' },
        waiting: { label: 'Aguardando entrega', value: '' },
        other: { label: 'Outros', value: '' },
      };
      if (user.dataHoraCriacao) {
        _mountCharts();
        return;
      }
      ClienteResource.getProfile({ idCliente: user.id })
        .$promise
        .then(function(response){
          user.dataHoraCriacao = response.dataHoraCriacao;
          localStorageService.set('user', user);
          _mountCharts();
        }, function(err){
          console.log('Error API clientes', err);
        });
    };
    ctrl.onDateChange = function () {
      _getCharts();
    };
    var INIT_DATE = '2017-04-01'; // TODO: update this when it's live
    var _totalValues = function (values) {
      return _.reduce(values, function(result, value){
        return result + value;
      }, 0);
    };
    var _getPercentage = function (value, total, digits) {
      if (value == 0 || total == 0){
        return 0.0;
      }_
      digits = digits || 2;
      return +((value/total) * 100).toFixed(digits);
    };
    var _setDeliveries = function (shipments, totalShipments) {
      var deliveryValues = _.pick(shipments, ['entregueDentroPrazo', 'entregueComAtraso']);
      ctrl.deliveries = _totalValues(deliveryValues);
      ctrl.deliveriesPercent = _getPercentage(ctrl.deliveries, totalShipments);
    };
    var _setBarValues = function (totalShipments) {
      ctrl.bars['onDate'].value  = _getPercentage(ctrl.shipments.entregueDentroPrazo, totalShipments);
      ctrl.bars['overdue'].value = _getPercentage(ctrl.shipments.entregueComAtraso, totalShipments);
      ctrl.bars['waiting'].value = _getPercentage(ctrl.shipments.aguardandoEntrega, totalShipments);
      ctrl.bars['other'].value   = _getPercentage(ctrl.shipments.outros, totalShipments);
    };
    var _mountCharts = function () {
      ctrl.mounths = _mountSelect(user.dataHoraCriacao);
      _getCharts();
    };
    var _mountSelect = function (startDate) {
      var nowNormalized = moment().startOf('month'),
        initDate = moment(startDate).isBefore(INIT_DATE) ? INIT_DATE : startDate,
        startDateNormalized = moment(initDate).clone().startOf('month'),
        date = moment().startOf('month'),
        months = [];
      while (startDateNormalized.isBefore(nowNormalized)) {
        months.push({
          label: startDateNormalized.format('MMMM/YYYY'),
          value: startDateNormalized.toISOString(),
        });
        startDateNormalized.add(1, 'M');
      }
      ctrl.selectedDate = {
        label: date.format('MMMM/YYYY'),
        value: date.toISOString(),
      };
      months.push(ctrl.selectedDate);

      return months;
    };
    var _getCharts = function () {
      ctrl.isLoading = true;
      ChartsService.get({ idClient: user.id }, {data: ctrl.selectedDate.value})
        .$promise
        .then(function(response) {
          ctrl.isLoading = false;
          ctrl.shipments = response.envios;
          var shipmentsValues = _.omit(ctrl.shipments, ['clienteId', 'periodo']);
          ctrl.totalShipments = _totalValues(shipmentsValues);
          _setDeliveries(ctrl.shipments, ctrl.totalShipments);
          _setBarValues(ctrl.totalShipments);
        }, function(err) {
          ctrl.isLoading = false;
          console.log('Error: ChartsService GET', err.statusText);
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('ChartsCtrl', ChartsCtrl);
})();
